export default __webpack_public_path__ + "static/media/substract.81c51b0a.svg";